module.exports = __webpack_public_path__ + "static/media/bg-pic-main.923e0364.jpg";